"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGURATION_TYPE = void 0;
exports.CONFIGURATION_TYPE = {
    GLOBAL_APP_MESSAGE: 'global_app_message',
    SCHEDULED_NOTIFICATIONS_NO_WORK_ORDER_CREATED_FEATURE_IS_ENABLED: 'scheduled_notifications_no_work_order_created_feature_is_enabled',
    SCHEDULED_NOTIFICATIONS_NO_WORK_ORDER_CREATED_TIME_IN_DAYS: 'scheduled_notifications_no_work_order_created_time_in_days',
    SCHEDULED_NOTIFICATIONS_NO_WORK_ORDER_CREATED_REMINDER_TIME_IN_DAYS: 'scheduled_notifications_no_work_order_created_reminder_time_in_days',
    SCHEDULED_NOTIFICATIONS_OVERDUE_WORK_ORDER_FEATURE_IS_ENABLED: 'scheduled_notifications_overdue_work_order_feature_is_enabled',
    SCHEDULED_NOTIFICATIONS_OVERDUE_WORK_ORDER_REMINDER_TIME_IN_DAYS: 'scheduled_notifications_overdue_work_order_reminder_time_in_days',
    IN_APP_BIDS_FEATURE_IS_ENABLED: 'in_app_bids_feature_is_enabled',
    WORK_ORDER_CREATION_INTERNAL_EMAIL_LIST: 'work_order_creation_internal_email_list',
    DISPLAY_TENANT_PORTAL_POPUP: 'display_tenant_portal_popup',
    CONCIERGE_FEATURE_FRONTEND_IS_ENABLED: 'concierge_frontend_feature_is_enabled',
    WARRANTY_PRODUCT_IS_ENABLED: 'warranty_product_is_enabled',
    WORK_ORDER_ISSUE_TYPE_IDS_ALLOW_LIST: 'work_order_issue_type_ids_allow_list',
    GET_APP_CTA_IN_MOBILE_BROWSER_IS_ENABLED: 'get_app_cta_in_mobile_browser_is_enabled',
    CONCIERGE_VENDORS_IS_ENABLED: 'concierge_vendors_is_enabled',
    NON_WARRANTY_WORK_ORDER_CREATION_IS_ENABLED: 'non_warranty_work_order_creation_is_enabled',
};
//# sourceMappingURL=configuration.types.js.map